import { Injectable } from '@angular/core';
import { fromEvent } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CookiebotService {



  loadCookiebot(lang:string){
    let div :HTMLElement | null = document.querySelector('#cookieContainer');  
    let src = `https://consent.cookiebot.com/e360ce47-3b41-46a1-8517-e0c59e204310/cd.js`;
    let script: HTMLScriptElement  = document.createElement("script");
    script.id = "CookieDeclaration";
    script.src = src;
    script.type = "text/javascript";
    script.setAttribute("data-culture",lang);
    div?.appendChild(script);
  }

  eventOnDialogInit(lang:string){
    fromEvent(window, "CookiebotOnDialogDisplay").subscribe((eventCookie: any)=>{
      console.log("CookiebotOnDialogDisplay",eventCookie );
      let a :any = document.querySelector("#CybotCookiebotDialogTabContent #CybotCookiebotDialogBodyContentText a[href='/cookies']"); 
      if(a){
        a.href = lang+"/cookies";
        a.target = "_blank";
      }
      
    });
  }
}
